import { createSlice } from '@reduxjs/toolkit';

const DashboardFiltersReducer = createSlice({
    name:'bar_controller',
    initialState:{},
    reducers:{
        saveFilters:{
            reducer:(state, action) => (state = action.payload),
            prepare: (value) => ({ payload: value }),
        }
    }
})

export const {saveFilters} = DashboardFiltersReducer.actions;
export default DashboardFiltersReducer.reducer
